export type Sucursal = any

export interface SucursalSettings {
    showHSP: boolean
    showComisiones: boolean
}

export interface SucursalsState {
    loading: boolean
    sucursals: Sucursal[]
    resultsuscursal: string | null
    informes: any
    settings: SucursalSettings
}

const initialState: SucursalsState = {
    loading: false,
    sucursals: [],
    resultsuscursal: null,
    informes: [],
    settings: { showHSP: true, showComisiones: true }
}

export const sucursalsReducer = (state: SucursalsState = initialState, action: { type: string; payload?: any }): SucursalsState => {
    switch (action.type) {
        case "SUCURSAL_GETALL_SUCCESS":
            return {
                ...state,
                sucursals: action.payload.sucursals as Sucursal[]
            }
        case "SUCURSALS_IMPORT_SUCCESS":
            return {
                ...state,
                sucursals: action.payload.sucursals as Sucursal[]
            }
        case "SUCURSALS_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "SUCURSALS_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }
        case "SUCURSAL_ADD_REPORT_SUCCESS":
            return {
                ...state,
                resultsuscursal: action.payload.message,
                sucursals: state.sucursals.map((u: any) =>
                    u._id === action.payload.sucursal._id ? (action.payload.sucursal as Sucursal) : u
                )
            }
        case "SUCURSAL_DELETE_REPORT_SUCCESS":
            return {
                ...state,
                resultsuscursal: action.payload.message,
                sucursals: state.sucursals.map((u: any) =>
                    u._id === action.payload.sucursal._id ? (action.payload.sucursal as Sucursal) : u
                )
            }
        case "SUCURSAL_EDIT_REPORT_SUCCESS":
            return {
                ...state,
                resultsuscursal: action.payload.message,
                sucursals: state.sucursals.map((u: any) =>
                    u._id === action.payload.sucursal._id ? (action.payload.sucursal as Sucursal) : u
                )
            }
        case "SUCURSAL_GET_ALL_REPORTS_SUCCESS":
            return {
                ...state,
                informes: action.payload.informes
            }
        case "SUCURSAL_GET_SETTINGS_SUCCESS":
            return {
                ...state,
                settings: {
                    showHSP: action.payload.showHSP,
                    showComisiones: action.payload.showComisiones
                }
            }
        case "SUCURSAL_UPDATE_SETTINGS_SUCCESS":
            return {
                ...state,
                resultsuscursal: action.payload.message,
                settings: {
                    showHSP: action.payload.showHSP,
                    showComisiones: action.payload.showComisiones
                }
            }
        case "SUCURSAL_RESET_RESULT":
            return {
                ...state,
                resultsuscursal: null,
            }
        default:
            return state
    }
}
